export const FOLLOWER_PAGE = 1;
export const FOLLOWER_SIZE = 10;

export const DATE_FORMAT_TIME = 'DD/MM/YYYY - hh:mm:ss';
export const DATE_FORMAT = 'YYYY-MM-DD';
